"use client";

import { Home } from "lucide-react";
import Link from "next/link";
import { useAppStore, currentView } from "@/lib/store";
import { useI18n } from "@/lib/i18n/provider";

export function Footer() {
  const { goHome, openArea, user } = useAppStore();
  const { t } = useI18n();
  const year = new Date().getFullYear();
  return (
    <footer className="mt-auto border-t bg-muted/40">
      <div className="mx-auto max-w-7xl px-4 py-10 sm:px-6">
        <div className="grid gap-8 md:grid-cols-4">
          <div className="space-y-3">
            <div className="flex items-center gap-2 font-semibold">
              <span className="grid h-8 w-8 place-items-center rounded-lg bg-primary text-primary-foreground">
                <Home className="h-4 w-4" />
              </span>
              {t("app.name")}
            </div>
            <p className="text-sm text-muted-foreground">{t("footer.tagline")}</p>
          </div>

          <div>
            <h4 className="mb-3 text-sm font-semibold">{t("footer.explore")}</h4>
            <ul className="space-y-2 text-sm text-muted-foreground">
              <li>
                <button onClick={() => openArea("browse")} className="hover:text-foreground">
                  {t("footer.allProperties")}
                </button>
              </li>
              {user && (
                <li>
                  <button
                    onClick={() => openArea("my-reservations")}
                    className="hover:text-foreground"
                  >
                    {t("footer.myTrips")}
                  </button>
                </li>
              )}
              <li>
                <Link href="/documentation" className="hover:text-foreground">
                  {t("nav.documentation")}
                </Link>
              </li>
              <li>
                <Link href="/houses" className="hover:text-foreground">
                  {t("footer.publicPages")}
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="mb-3 text-sm font-semibold">{t("footer.forHosts")}</h4>
            <ul className="space-y-2 text-sm text-muted-foreground">
              <li>{t("footer.host1")}</li>
              <li>{t("footer.host2")}</li>
              <li>{t("footer.host3")}</li>
            </ul>
          </div>

          <div>
            <h4 className="mb-3 text-sm font-semibold">{t("footer.roadmap")}</h4>
            <ul className="space-y-2 text-sm text-muted-foreground">
              <li>{t("footer.roadmap1")}</li>
              <li>{t("footer.roadmap2")}</li>
              <li>{t("footer.roadmap3")}</li>
            </ul>
          </div>
        </div>

        <div className="mt-8 border-t pt-6 text-sm text-muted-foreground">
          <div className="flex flex-col items-center justify-between gap-3 sm:flex-row">
            <p>&copy; {year} {t("app.name")}. {t("footer.rights")}</p>
            <p className="text-xs">{t("footer.builtWith")}</p>
          </div>
        </div>
      </div>
    </footer>
  );
}
